import {isNotNil, uniq} from 'ramda';

import {ConversationUser} from '@chat/shared/validations';

export function getDmsSenderUserIds(events: Array<{sender: ConversationUser}>) {
  return uniq(
    events
      .map((event) => event.sender)
      .filter((sender) => sender.type === 'DMS')
      .map((sender) => sender.externalUserId)
      .filter(isNotNil)
  );
}
